import { createSelector } from '@ngrx/store';

import {
  BillOfMaterialsState,
  VitescoBillOfMaterialsState,
} from '@cdba/core/store/reducers/detail/detail.reducer';
import { VitescoBomItem } from '@cdba/shared/models/vitesco-bom-item.model';

import {
  isVitescoBillOfMaterialGuard,
  selectBillOfMaterialsState,
} from './common-bom.selector';

export const selectVitescoTypedState = createSelector(
  selectBillOfMaterialsState,
  (state: BillOfMaterialsState): VitescoBillOfMaterialsState | undefined =>
    isVitescoBillOfMaterialGuard(state) ? state : undefined
);

export const selectVitescoItems = createSelector(
  selectVitescoTypedState,
  (state: VitescoBillOfMaterialsState): VitescoBomItem[] | undefined =>
    state?.items
);
